import { Expense } from "@finway-group/shared/lib/models"
import { Col, DatePicker, Form, Row } from "antd"
import { FormInstance } from "antd/lib/form"
import { Store } from "antd/lib/form/interface"
import moment from "moment"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { gobdNonCompliantDates } from "~Shared/utils/date.utils"
import { useStateIfMounted } from "~Shared/utils/hooks/useStateIfMounted"
import { getPopupAnchor } from "~Shared/utils/popup.utils"
import { CurrencySelect } from "./expenseForm/commonInputFields/CurrencySelect"
import TotalAmountForm from "./expenseForm/commonInputFields/totalAmount.form"
import { ExpenseRules } from "./rules"

interface CreateRecurringExpenseFormProps {
    formInstance: FormInstance
    handleSubmit: (values: Store) => void
    parentSubscription: Expense
}

export const CreateRecurringExpenseForm = ({ formInstance, handleSubmit, parentSubscription }: CreateRecurringExpenseFormProps) => {
    const { t } = useTranslation()
    const [isLinked, setIsLinked] = useStateIfMounted(true)
    const [expense, setExpense] = useState<Expense>(new Expense({ ...parentSubscription, datePurchased: moment() }))
    const { datePurchased } = ExpenseRules({ expense })

    useEffect(() => {
        formInstance.setFieldsValue({ ...formInstance.getFieldsValue(), ...expense })
    }, [expense])

    const updateExpense = (data: any) => {
        const formData = formInstance.getFieldsValue()
        setExpense((old) => new Expense({ ...old, ...formData, ...data }))
    }

    return (
        <div>
            <Form form={formInstance} layout="vertical" onFinish={handleSubmit}>
                <TotalAmountForm expense={expense} updateExpense={updateExpense} isLinked={isLinked} setIsLinked={setIsLinked} expenseForm={formInstance} isNew={true} />
                <Row gutter={[16, 16]}>
                    <Col span={12} sm="24">
                        <Form.Item label={t("input:request.date")} key="datePurchased" name="datePurchased" required rules={datePurchased}>
                            <DatePicker
                                name="datePurchased"
                                style={{ width: "100%" }}
                                format={moment.localeData().longDateFormat("L")}
                                placeholder={t("placeholder:request.date")}
                                getPopupContainer={getPopupAnchor()}
                                disabledDate={gobdNonCompliantDates}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={12} sm="24">
                        <CurrencySelect initialValue={parentSubscription.currency} onCurrencyChange={updateExpense} />
                    </Col>
                </Row>
            </Form>
        </div>
    )
}
